export default __webpack_public_path__ + "static/media/landing-bg.ac0a218f.png";